var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Enviar Expediente " + _vm.file.numero,
        "hide-footer": "",
        centered: ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", [
        _c("h5", [_vm._v(" Para: ")]),
        _c(
          "div",
          { staticClass: "wrap-option" },
          [
            _c(
              "vs-radio",
              {
                attrs: { "vs-value": "moodUser" },
                model: {
                  value: _vm.subject.typeSend,
                  callback: function($$v) {
                    _vm.$set(_vm.subject, "typeSend", $$v)
                  },
                  expression: "subject.typeSend"
                }
              },
              [_vm._v("Usuario")]
            ),
            _c(
              "vs-radio",
              {
                attrs: { "vs-value": "moodGroup" },
                model: {
                  value: _vm.subject.typeSend,
                  callback: function($$v) {
                    _vm.$set(_vm.subject, "typeSend", $$v)
                  },
                  expression: "subject.typeSend"
                }
              },
              [_vm._v("Unidad")]
            )
          ],
          1
        ),
        _vm.subject.typeSend === "moodUser" &&
        _vm.usersCompany &&
        _vm.usersCompany.length
          ? _c(
              "div",
              { staticClass: "wrap-form" },
              [
                _c("list-user", {
                  staticClass: "w-100",
                  attrs: { name: "user", block: false, label: "Usuarios" },
                  model: {
                    value: _vm.subject.user,
                    callback: function($$v) {
                      _vm.$set(_vm.subject, "user", $$v)
                    },
                    expression: "subject.user"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.isAguasAndinas && _vm.subject.typeSend === "moodUser"
          ? _c("div", [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 text-danger my-2" }, [
                  _vm._v(
                    " El destinatario responsable actual tiene la providencia "
                  ),
                  _c("span", [_vm._v(_vm._s(_vm.providenceSubject))]),
                  _vm.providence.providenciaVencimiento
                    ? _c("span", [
                        _vm._v(
                          " con fecha de vencimiento " +
                            _vm._s(
                              _vm._f("dateFormat")(
                                _vm.providence.providenciaVencimiento
                              )
                            ) +
                            " "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm.providenceSubject === "gestión"
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("label", [_vm._v("Fecha Vencimiento")]),
                        _c("b-form-datepicker", {
                          attrs: {
                            min: _vm.minDate,
                            max: _vm.maxDate,
                            "show-decade-nav": false,
                            "hide-header": false,
                            placeholder: "Fecha vencimiento",
                            name: "providenceExpiration",
                            "data-vv-as": "fecha vencimiento",
                            "label-help":
                              "Puede usar las flechas del teclado y espacio",
                            "data-cy": "calendar"
                          },
                          model: {
                            value: _vm.providenceDate,
                            callback: function($$v) {
                              _vm.providenceDate = $$v
                            },
                            expression: "providenceDate"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm.subject.typeSend === "moodGroup" &&
        _vm.groupsCompany &&
        _vm.groupsCompany.length
          ? _c(
              "div",
              { staticClass: "wrap-form" },
              [
                _c("list-groups", {
                  staticClass: "w-100",
                  attrs: { name: "group", block: false, label: "Unidad" },
                  model: {
                    value: _vm.subject.group,
                    callback: function($$v) {
                      _vm.$set(_vm.subject, "group", $$v)
                    },
                    expression: "subject.group"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "wrap-commentary" },
          [
            _c("vs-textarea", {
              attrs: {
                "data-cy": "comment",
                maxlength: "255",
                label: "Comentario"
              },
              model: {
                value: _vm.subject.commentary,
                callback: function($$v) {
                  _vm.$set(_vm.subject, "commentary", $$v)
                },
                expression: "subject.commentary"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        [
          _c(
            "vs-collapse",
            [
              _c("vs-collapse-item", [
                _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                  _c("h5", [_vm._v(" Con copia: ")])
                ]),
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "wrap-option" },
                    [
                      _c(
                        "vs-radio",
                        {
                          attrs: { "vs-value": "sendUser" },
                          model: {
                            value: _vm.copy.typeCopy,
                            callback: function($$v) {
                              _vm.$set(_vm.copy, "typeCopy", $$v)
                            },
                            expression: "copy.typeCopy"
                          }
                        },
                        [_vm._v("Usuario")]
                      ),
                      _c(
                        "vs-radio",
                        {
                          attrs: { "vs-value": "sendGroup" },
                          model: {
                            value: _vm.copy.typeCopy,
                            callback: function($$v) {
                              _vm.$set(_vm.copy, "typeCopy", $$v)
                            },
                            expression: "copy.typeCopy"
                          }
                        },
                        [_vm._v("Unidad")]
                      )
                    ],
                    1
                  ),
                  _vm.copy.typeCopy === "sendUser" &&
                  _vm.usersCompany &&
                  _vm.usersCompany.length
                    ? _c(
                        "div",
                        { staticClass: "wrap-form" },
                        [
                          _c("list-user", {
                            staticClass: "w-100",
                            attrs: {
                              name: "user",
                              block: false,
                              label: "Usuarios"
                            },
                            model: {
                              value: _vm.copy.user,
                              callback: function($$v) {
                                _vm.$set(_vm.copy, "user", $$v)
                              },
                              expression: "copy.user"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.copy.typeCopy === "sendGroup" &&
                  _vm.groupsCompany &&
                  _vm.groupsCompany.length
                    ? _c(
                        "div",
                        { staticClass: "wrap-form" },
                        [
                          _c("list-groups", {
                            staticClass: "w-100",
                            attrs: {
                              name: "group",
                              block: false,
                              label: "Unidad"
                            },
                            model: {
                              value: _vm.copy.group,
                              callback: function($$v) {
                                _vm.$set(_vm.copy, "group", $$v)
                              },
                              expression: "copy.group"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "m-top-20" },
                    [
                      _c("vs-textarea", {
                        attrs: { maxlength: "255", label: "Comentario" },
                        model: {
                          value: _vm.copy.commentary,
                          callback: function($$v) {
                            _vm.$set(_vm.copy, "commentary", $$v)
                          },
                          expression: "copy.commentary"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "m-top-20 text-center" },
        [
          _c(
            "vs-button",
            {
              attrs: { "data-cy": "send", color: "primary", type: "border" },
              on: {
                click: function($event) {
                  return _vm.sendFileToSubjects()
                }
              }
            },
            [_vm._v(" Enviar Expediente ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }